module.exports = __webpack_public_path__ + "static/media/loc7_img2.03b3aa0f.jpg";